<template>
  <div>
    <div class="management-detail">
      <detail-info
        :title="busTitle"
        :detailData="detailDataBusiness"
        :detailGetData="detailGetData.businessInfoBO"
      />
      <detail-info
        :title="legalRepTitle"
        :detailData="legalRepData"
        :detailGetData="detailGetData.businessInfoBO"
      />
      <detail-info
        :title="financeInfoTitle"
        :detailData="financeInfoData"
        :detailGetData="detailGetData.businessInfoBO"
      />
      <el-card-title :title="title" />

      <div style="height: 20px"></div>

      <div class="row-content">
        <div class="detail-label logoLabel">店铺LOGO：</div>
        <div class="detail-lableImg" @click="parentView(shopLogoUrl, 'logo')">
          <img :src="shopLogoUrl" alt="" />
        </div>
      </div>
      <template v-for="(item, idx) in detailData">
        <div class="row-content" :key="idx">
          <div class="detail-label" v-if="item.isShow">{{ item.label }}：</div>
          <div
            :class="
              item.valueKey === 'categoryBos'
                ? 'detail-value categoryBos-wrapper'
                : 'detail-value'
            "
          >
            <div class="categoryBos" v-if="item.valueKey === 'classifyBos'">
              <div
                v-for="(categoryBosItem, idx) in detailGetData[item.valueKey]"
                :key="idx"
              >
                {{ categoryBosItem.classifyNames }}
              </div>
            </div>
            <div class="categoryBos" v-else-if="item.valueKey === 'saleLimitUnits'">
              <el-button
                v-if="detailGetData['saleLimitUnits'].length > 0"
                class="default-button"
                size="mini"
                type="default-mini"
                @click="openCompanyDialog"
              >点击查看
              </el-button>
            </div>
            <div class="categoryBos" v-else-if="item.valueKey === 'categoryBos'">
              <div
                v-for="(categoryBosItem, idx) in detailGetData[item.valueKey]"
                :key="idx"
              >
                {{ categoryBosItem.categoryNames }}
              </div>
            </div>
            <template v-else>{{ detailGetData[item.valueKey] }}</template>
          </div>
        </div>
      </template>
      <el-card-title :title="title2" />
      <div class="detail-bottom">
        <el-row type="flex" justify="start" :gutter="20">
          <el-col
            :span="6"
            v-for="(item, idx) in detailGetData.shopAptitudeInfoBOS"
            :key="idx"
          >
            <div class="bottom-img" @click="parentView(item)">
              <el-image
                :class="{ backgroundNone: item.isBase64 }"
                style="width: 103px; height: 140px"
                fit="scale-down"
                :src="item.aptitudeUrl"
                alt=""
                @click="detailsHand(item)"
              />
            </div>
            <div class="bottom-text">
              <span>{{ item.aptitudeName }}</span>
              <span
                :title="
                  item.networkAddress
                    ? item.networkAddress
                    : item.certificateAuthority
                "
                >发证机关：{{
                  item.networkAddress
                    ? item.networkAddress
                    : item.certificateAuthority
                }}</span
              >
              <span
                v-if="!isFileDate.includes(item.aptitudeName)"
                :title="item | dateFilter"
                >有效期：{{ item | dateFilter }}</span
              >
              <!--<span v-if="isFileDate.includes(item.aptitudeName)" style="visibility: hidden;">是是是</span>-->
            </div>
            <p class="file-list-body-desc-file" @click="downloadFile(item)">
              下载文件
              <i class="icon-ccui-download"></i>
            </p>
          </el-col>
        </el-row>
      </div>
      <div style="height: 20px"></div>
      <div class="footer-step-lyp">
        <div class="step-right-lyp" @click="crumbsBack">返回</div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" title="操作">
      <img width="100%" :src="dialogImageUrl" alt />
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="companyDialogVisible"
      class="applicableUnit"
      title="适用单位"
      width="1100px"
    >
      <div class="ccui-multifunctional-table-wrapper" style="width: 100%">
        <el-table
          ref="multipleTable"
          :data="rangeUnitNameList"
          :show-header-overflow="true"
          :show-overflow="true"
          border
          max-height="9999999"
          style="width: 100%"
        >
          <el-table-column fixed="left" label="序号" type="index" width="60" />
          <el-table-column
            prop="unitName"
            show-overflow-tooltip
            label="单位名称"
          >
          </el-table-column>
          <el-table-column
            prop="unitAbbrName"
            show-overflow-tooltip
            label="单位简称"
          >
          </el-table-column>
          <el-table-column
            prop="contractRangeExplain"
            show-overflow-tooltip
            title="适用范围"
          >
            <template slot-scope="scope">
              {{scope.row.contractRangeExplain?scope.row.contractRangeExplain:'本级及下级'}}
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div v-if="detailGetData['saleLimitUnits'].length != 0" style="margin: 20px 0 10px 0">
        <div class="ccui-table-footer">
          <div id="ccui-paging" style="float: none; justify-content: right">
            <el-pagination
              :current-page="page.pageNo"
              :page-size="page.pageSize"
              :pagesize="pagesize"
              :total="page.total"
              background
              layout="total, sizes, prev, pager, next, jumper"
              next-text="下一页 >"
              popper-class="ccui-paging-page-size-popper"
              prev-text="< 上一页"
              @addCurrentPage="internalCurrentPage"
              @prev-click="handlePrev"
              @next-click="handleNext"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <!-- 分页 -->
        <el-button
          size="mini"
          type="primary-font-mini"
          @click="companyDialogVisible = false"
        >关闭</el-button
        >
      </span>
    </el-dialog>
    <el-dialog :visible.sync="pdfPreview">
      <iframe
        ref="pdf"
        :src="downloadUrl"
        frameborder="0"
        scrolling="auto"
        style="min-width: 900px;min-height: 500px"
        type="application/x-google-chrome-pdf"
      ></iframe>
    </el-dialog>
  </div>
</template>
<script>
import {addUrlPerFix} from  "@/utils/index.js"
import { qryShopDetails } from "@/api/shop-detail-info";
import images from "@/assets/404_images/404.png";
import shopDefaultLogo from "@/assets/images/defaule-shop-logo.png";
import imgBase64 from "./img-base64";
import { dateFitler } from "@/utils/validate";
import detailInfo from "./detail-info.vue";
export default {
  name: "shopDetailInfo",
  components: {
    detailInfo,
  },
  data() {
    return {
      page: {
        total: 0,
        pageNo: 1,
        pageSize: 10
      },
      pagesize: [10, 20, 50, 100, 200, 500],
      companyDialogVisible: false, //适用单位弹窗
      rangeUnitNameList: [],
      downloadUrl:'',
      pdfPreview: false,
      isFileDate: ["法定代表人身份证"],
      // 基本信息
      busTitle: "基本信息",
      detailDataBusiness: [
        {
          label: "公司名称",
          value: "businessName",
        },
        {
          label: "公司简称",
          value: "businessShortname",
        },
        {
          label: "统一社会信用代码",
          value: "unifiedCode",
        },
        // {
        //   label: "工商注册号",
        //   value: "regNum"
        // },
        // {
        //   label: "组织机构代码",
        //   value: "orgCode"
        // },
        // {
        //   label: "纳税人识别号",
        //   value: "taxCode"
        // },
        {
          label: "住所",
          value: "address",
        },
        {
          label: "注册资本（万元）",
          value: "regCapl",
        },
        {
          label: "实收资本（万元）",
          value: "factCapl",
        },
        {
          label: "公司类型",
          value: "compTypeStr",
        },
        {
          label: "成立时间",
          value: "regTime",
        },
        {
          label: "所在区域",
          value: "area",
        },
        {
          label: "单位类别",
          value: "compClassStr",
        },
        {
          label: "办公地址",
          value: "officeAddress",
        },
        {
          label: "纳税人类型",
          value: "taxpayerIdStr",
        },
        {
          label: "经营范围",
          value: "businessScope",
        },
        {
          label: "公司联系电话",
          value: "businessTelephone",
        },
        {
          label: "联系人",
          value: "contactNameAndPhone",
        },
      ],
      // 法定人信息
      legalRepTitle: "法定代表人",
      legalRepData: [
        {
          label: "姓名",
          value: "legalPerson",
        },
        {
          label: "证件类型",
          value: "idTypeStr",
        },
        {
          label: "证件号码",
          value: "idNum",
        },
      ],
      // 财务信息
      financeInfoTitle: "财务信息",
      financeInfoData: [
        {
          label: "开户银行",
          value: "depositBank",
        },
        {
          label: "银行帐号",
          value: "bankNum",
        },
        {
          label: "开票地址",
          value: "billAddress",
        },
        {
          label: "开票电话",
          value: "billPhone",
        },
      ],
      shopDefaultLogo,
      dialogVisible: false,
      dialogImageUrl: "",
      images: images,
      imgUrl: this.$addUrlPerFix(process.env.VUE_APP_IMG_URL),
      title: "店铺信息",
      title2: "资质文件",
      detailData: [
        {
          label: "店铺名称",
          valueKey: "shopName",
          isShow:1
        },
        {
          label: "店铺编号",
          valueKey: "shopCode",
          isShow:1
        },
        {
          label: "销售范围是否限制",
          valueKey: "saleLimitFlag",
          isShow:1
        },
        {
          label: "销售类目",
          valueKey: "classifyBos",
          isShow:1
        },
        {
          label: "适用单位",
          valueKey: "saleLimitUnits",
          isShow:1
        },
        {
          label: "适用区域",
          valueKey: "saleLimitAreaName",
          isShow:1
        },
        {
          label: "经营类目",
          valueKey: "categoryBos",
          isShow:1
        },

        {
          label: "合作类型",
          valueKey: "cooperationType",
          isShow:1
        },
        {
          label: "店铺类型",
          valueKey: "shopTypeName",
          isShow:1
        },
        {
          label: "店长（手机号）",
          valueKey: "managerAndPhone",
          isShow:1
        },
        {
          label: "E-mail地址",
          valueKey: "shopManagerEmail",
          isShow:1
        },
        {
          label: "店铺经营地址",
          valueKey: "shopAddress",
          isShow:1
        },
        {
          label: "客服电话",
          valueKey: "supportPhone",
          isShow:1
        },
        {
          label: "店铺简介",
          valueKey: "shopBrief",
          isShow:1
        },
      ],
      detailGetData: {
        shopAptitudeInfoBOS: [],
        categoryBos: [],
        classifyBos: [],
        businessInfoBO: {},
      },
      shopType: [
        '品类经营店',
        '厂家直营店',
        '品牌专卖店',
         '综合经营店',
        '平台自营店',
        '扶贫直销店'
      ],
      cooperationType: ["联营", "区域联采", "集采", "自营"],
      shopStatus: ["运营中", "已关闭", "已注销", "试运营"],
      fileType: [
        { type: "xls,xlsx", base64: imgBase64.xls },
        { type: "doc,docx", base64: imgBase64.doc },
        { type: "zip,rar", base64: imgBase64.zip },
        { type: "txt", base64: imgBase64.txt },
        { type: "pdf", base64: imgBase64.pdf },
      ],
    };
  },
  mounted() {
    this.qryShopDetails();
  },
  computed: {
    shopLogoUrl() {
      return this.detailGetData.shopLogoUrl
        ? this.detailGetData.shopLogoUrl
        : this.shopDefaultLogo;
    },
    desDecryptShopId() {
      return this.$crypto.Decrypt(this.$route.params.listId);
    },
  },
  filters: {
    dateFilter(data) {
      let retunData = "";
      if (data.effectBeginTime && data.effectEndTime) {
        retunData = data.effectBeginTime + "至" + data.effectEndTime;
      }
      if (!data.effectEndTime) {
        retunData = data.effectBeginTime + "至长期";
      }
      if (!data.effectEndTime && !data.effectBeginTime) {
        retunData = "";
      }
      return retunData;
    },
  },
  methods: {
    // 打开适用单位弹窗
    openCompanyDialog() {
      console.log(this.companyDialogVisible)
      this.companyDialogVisible = true
      this.page.pageNo = 1
      this.page.pageSize = 10
      this.page.total = this.detailGetData['saleLimitUnits'].length
      this.rangeUnitNameList = this.pagingFun(
        this.detailGetData['saleLimitUnits'],
        this.page.pageNo,
        this.page.pageSize
      )
    },
    internalCurrentPage(val) {},
    handleCurrentChange(val) {
      this.page.pageNo = val
      this.rangeUnitNameList = this.pagingFun(
        this.detailGetData['saleLimitUnits'],
        this.page.pageNo,
        this.page.pageSize
      )
    },
    handlePrev() {},
    handleNext() {},
    handleSizeChange(val) {
      this.page.pageSize = val
      this.page.pageNo = 1
      this.rangeUnitNameList = this.pagingFun(
        this.detailGetData['saleLimitUnits'],
        this.page.pageNo,
        this.page.pageSize
      )
    },
    pagingFun(tabdata, pageNo, pageSize) {
      return tabdata.slice((pageNo - 1) * pageSize, pageNo * pageSize)
    },
    downloadFile(item) {
      let fileInfoId = item.uploadId;
      let fileName = item.aptitudeName;
      let openUrl = document.createElement("a");
      openUrl.style.display = "none";
      openUrl.href = `${addUrlPerFix(
        process.env.VUE_APP_BASE_URL
      )}/apis/sra/store/users/signup/downloadByUploadId?uploadId=${fileInfoId}`+`&fileName=${fileName}`;
      console.log(openUrl.href,'openUrl.href')
      openUrl.setAttribute("download", fileName);

      document.body.appendChild(openUrl);
      openUrl.click();
    },
    detailsHand(item) {
      console.log(item, 'dataaaa')
      let xlsx = /xlsx$/
      let xls = /xls$/
      let docx = /docx$/
      let doc = /doc$/
      let reg = /pdf$/
      if (
        !(
          xlsx.test(item.downloadUrl) ||
          docx.test(item.downloadUrl) ||
          doc.test(item.downloadUrl) ||
          xls.test(item.downloadUrl)
        )
      ) {
        this.dialogPreview = true
      }
      if (reg.test(item.downloadUrl)) {
        this.pdfPreview = true
        this.downloadUrl = item.downloadUrl
        console.log(this.downloadUrl)
        this.dialogPreview = false
        //   this.messageInfo("warning", "该文件类型不支持预览");  改样式了，不要提示了，
        return
      }
      // this.dialogPreview = true
      this.dialogImageUrl = item.aptitudeUrl
      // if (item.isImage == 0) {
      //   this.$message.closeAll();
      //   this.$message({
      //     message: "该文件类型，不支持预览",
      //     type: "warning",
      //     offset: 400,
      //   });
      // }
    },
    crumbsBack() {
      this.$emit("crumbsBack");
    },
    parentView(item, logo) {
      if (logo) {
        this.dialogVisible = true;
        this.dialogImageUrl = item;
        return false;
      }
      if (!item.isBase64) {
        this.dialogVisible = true;
        this.dialogImageUrl = item.aptitudeUrl;
      }
    },
    qryShopDetails() {
      qryShopDetails({
        shopId: this.$store.state.app.userRegisterInfo.shopId,
        isShowLoading: true,
      }).then((res) => {
        if (res.data.code === "0") {
          this.detailGetData = res.data.data;
          let detailData1= JSON.parse(JSON.stringify(this.detailData))
          if (this.detailGetData.saleLimitFlag==0){
            this.detailData= this.detailData.filter(item =>!['classifyBos','saleLimitUnits','saleLimitAreaName'].includes(item.valueKey));
          }
          this.detailGetData.saleLimitFlag= this.detailGetData.saleLimitFlag==1?'是':'否'

          if (!this.detailGetData.businessInfoBO) {
            this.detailGetData.businessInfoBO = {};
          }
          console.log(
            "范德萨范德萨范德萨范德萨",
            this.detailGetData.businessInfoBO
          );
          this.detailGetData.shopAptitudeInfoBOS.forEach((item) => {
            let urlFileTypeArr = item.aptitudeUrl.split("?")[0].split(".");
            let urlFileType = urlFileTypeArr[urlFileTypeArr.length - 1];
            this.fileType.forEach((itemBase) => {
              if (urlFileType) {
                if (itemBase.type.includes(urlFileType.toLowerCase())) {
                  item.aptitudeUrl = itemBase.base64;
                  item.isBase64 = true;
                }
              }
            });
          });
          this.detailGetData.shopStatusName = this.shopStatus[
            this.detailGetData.shopStatus
          ];
          this.detailGetData.shopTypeName = this.shopType[
            this.detailGetData.shopType
          ];
          if (this.detailGetData.cooperationType!=9){
            this.detailGetData.cooperationType = this.cooperationType[
              this.detailGetData.cooperationType
              ];
          }else {
            this.detailGetData.cooperationType=''
          }
          console.log(this.detailGetData.cooperationType,'this.detailGetData.cooperationType')
        }
      });
    },
    updateDate() {
      let thisDate = dateFitler(new Date().toLocaleDateString());
      this.detailGetData.allTime = thisDate;
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-dialog__body {
  user-select: none;
}
.logoLabel {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
}
/deep/ .el-card-title {
  margin-left: 0 !important;
}
/deep/ .el-dialog__header {
  .el-dialog__title {
    //opacity: 0;
  }
}
/deep/.el-button span{
  //color: #e9e9e9!important;
}
/deep/.el-dialog__footer .el-button.el-button--primary-font-mini{
  background-color: #ffffff;
}
.management-detail {
  padding: 12px 0 20px 20px;
  background-color: #fff;
  min-height: calc(100vh - 220px);
  margin: 15px 0 20px 0;
  .row-content {
    display: flex;
    margin-bottom: 20px;
  }
  .detail-label,
  .detail-value {
    font-size: 13px;
    font-weight: 400;
    color: #4a4a4a;
    line-height: 17px;
    position: relative;
    /deep/ .el-button {
      //margin-left: 21px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .detail-label {
    width: 160px;
    text-align: right;
  }
  .detail-value {
    width: calc(100% - 234px);
    padding-right: 54px;
    //white-space: pre-wrap;
    //white-space: -moz-pre-wrap;
    //white-space: -o-pre-wrap;
    word-wrap: break-word;
  }
  .categoryBos-wrapper {
  }
  .detail-lableImg {
    cursor: pointer;
    width: 200px;
    height: 60px;
    position: relative;
    img {
      width: 200px;
      height: 60px;
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .detail-bottom {
    padding: 0 100px;
    .el-row {
      flex-wrap: wrap;
      .el-col {
        margin-top: 20px;
      }
    }
    .bottom-img {
      cursor: pointer;
      width: 103px;
      height: 140px;
      margin-bottom: 10px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .bottom-text {
      span {
        display: block;
        font-size: 13px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #4a4a4a;
        line-height: 25px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      /*span:last-of-type {*/
      /*color: #5576cf;*/
      /*cursor: pointer;*/
      /*.icon-ccui-download {*/
      /*margin-left: 10px;*/
      /*}*/
      /*}*/
    }
  }
}
/deep/ .el-image {
  background: #f2f2f2;
}
/deep/ .backgroundNone {
  background: none !important;
}
/deep/ .el-image__inner {
  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    /* IE10以上 */
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
.file-list-body-desc-file {
  cursor: pointer;
  color: #5576cf;
  position: absolute;
  bottom: 0;
  i {
    margin-left: 10px;
  }
}
/deep/.el-col{
  height: 250px;
  position:relative!important
}
</style>
